import React from 'react';
import localization from '../helpers/localization.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
const DownloadAttachmentsPage = ({ benchVisulizationImage, benchCadImage, prevPage, nextPage }) => (
    <div className="page">
        <Row>
            <Col md={6} sm={12}>
                <h3>3d kuva</h3>
                <img src={benchVisulizationImage} className="img-fluid" ></img>
                <a href={benchVisulizationImage} download="laudekuva" className="orangeButton downloadImageButton"> <span className="buttonTxt">Lataa</span></a>
            </Col>
            <Col md={6} sm={12}>
                <h3>Pohjakuva </h3>
                <img id="caddownnloadimage" className="img-fluid" ></img>
                <a download="pohjakuva" id="caddownloadbutton" className="orangeButton downloadImageButton" > <span className="buttonTxt">Lataa</span></a>
            </Col>
        </Row>
        <div className="changePhaseRow">
            <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
            <span className="orangeButton changePhaseButton" onClick={() => { nextPage() }}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
        </div>
    </div>);

export default DownloadAttachmentsPage

